import TargetAudiencePage from './TargetAudiencePage';
import type { AudienceContent } from './TargetAudiencePage';

const content: { hr: AudienceContent; en: AudienceContent } = {
  hr: {
    meta: { title: 'Za agencije za upravljanje nekretninama | BookiApp', description: 'BookiApp za property management agencije. Upravljajte portfeljem od 10+ jedinica, tim članova, centralizirani kalendar i komunikacija.' },
    hero: { badge: 'ZA AGENCIJE', title: 'Upravljate s 10+ jedinica?', highlight: 'Skalirajte bez kaosa.', subtitle: 'Centralizirana komunikacija s gostima, multi-unit kalendar, tim članova i AI koji radi za vas - sve u jednoj platformi.', image: '🏢' },
    painPoints: {
      title: 'Izazovi agencija',
      items: [
        'Teško je pratiti komunikaciju s gostima za 10+ objekata',
        'Svaki član tima šalje različite upute gostima',
        'Duple rezervacije jer kalendari nisu sinkronizirani',
        'Gubite vrijeme na ručno unošenje rezervacija iz Booking.com/Airbnb',
        'Nemate pregled tko danas stiže u koji objekt',
        'Gosti ne dobivaju konzistentno iskustvo između objekata',
      ],
    },
    solutions: {
      title: 'BookiApp za agencije',
      subtitle: 'Profesionalna platforma za profesionalni tim',
      items: [
        { icon: 'users', title: 'Tim članova', desc: 'Dodajte upravitelje, kontakt osobe i podršku. Svaki član ima svoju ulogu i pristup.' },
        { icon: 'calendar', title: 'Centralizirani kalendar', desc: 'Sve jedinice na jednom ekranu. iCal sync s Booking.com i Airbnb za svaku jedinicu.' },
        { icon: 'sparkles', title: 'AI skeniranje rezervacija', desc: 'Slikajte potvrdu - AI popuni podatke. Uštedite sate ručnog unosa.' },
        { icon: 'shield', title: 'Zadane postavke objekta', desc: 'Postavite zadane vrijednosti na razini objekta. Nove jedinice automatski nasljeđuju postavke.' },
        { icon: 'messages', title: 'Centralizirani chat', desc: 'Svi razgovori s gostima na jednom mjestu. Vidite nepročitane poruke za sve objekte.' },
        { icon: 'creditcard', title: 'Praćenje uplata', desc: 'Evidentirajte uplate po rezervaciji. Gost vidi status plaćanja u svojoj aplikaciji.' },
      ],
    },
    stats: [
      { value: '249 EUR', label: 'godišnje (do 10 jedinica)' },
      { value: '∞', label: 'članova tima' },
      { value: '15 min', label: 'iCal sync interval' },
      { value: '24/7', label: 'AI asistent' },
    ],
    cta: { title: 'Profesionalizirajte svoju agenciju', subtitle: 'Jedna platforma za sve objekte, sve goste, cijeli tim.', button: 'Započni sada' },
  },
  en: {
    meta: { title: 'For property management agencies | BookiApp', description: 'BookiApp for property management agencies. Manage 10+ units, team members, centralized calendar and communication.' },
    hero: { badge: 'FOR AGENCIES', title: 'Managing 10+ units?', highlight: 'Scale without chaos.', subtitle: 'Centralized guest communication, multi-unit calendar, team members, and AI that works for you - all in one platform.', image: '🏢' },
    painPoints: {
      title: 'Agency challenges',
      items: [
        'Hard to track guest communication across 10+ properties',
        'Each team member sends different instructions to guests',
        'Double bookings because calendars aren\'t synced',
        'Wasting time manually entering bookings from Booking.com/Airbnb',
        'No overview of who\'s arriving today at which property',
        'Guests don\'t get consistent experience across properties',
      ],
    },
    solutions: {
      title: 'BookiApp for agencies',
      subtitle: 'Professional platform for professional teams',
      items: [
        { icon: 'users', title: 'Team members', desc: 'Add managers, contact persons, and support. Each member has their role and access.' },
        { icon: 'calendar', title: 'Centralized calendar', desc: 'All units on one screen. iCal sync with Booking.com and Airbnb for each unit.' },
        { icon: 'sparkles', title: 'AI booking scanner', desc: 'Photo the confirmation - AI fills in data. Save hours of manual entry.' },
        { icon: 'shield', title: 'Property Defaults', desc: 'Set defaults at property level. New units automatically inherit settings.' },
        { icon: 'messages', title: 'Centralized chat', desc: 'All guest conversations in one place. See unread messages for all properties.' },
        { icon: 'creditcard', title: 'Payment tracking', desc: 'Record payments per booking. Guest sees payment status in their app.' },
      ],
    },
    stats: [
      { value: '249 EUR', label: 'per year (up to 10 units)' },
      { value: '∞', label: 'team members' },
      { value: '15 min', label: 'iCal sync interval' },
      { value: '24/7', label: 'AI assistant' },
    ],
    cta: { title: 'Professionalize your agency', subtitle: 'One platform for all properties, all guests, your entire team.', button: 'Get started' },
  },
};

export default function ZaAgencijePage() {
  return <TargetAudiencePage content={content} canonical="/za-agencije" />;
}
